module.exports = __webpack_public_path__ + "img/bjsztitle.472484e3.png";